import React from 'react';
import { useConnectionStore } from '../../store/connectionStore';
import { useQueryClient } from '@tanstack/react-query';
import { AlertCircle, RefreshCw } from 'lucide-react';

export const ConnectionBanner: React.FC = () => {
    const { message, clearConnectionError } = useConnectionStore();
    const queryClient = useQueryClient();

    const handleRetry = () => {
        clearConnectionError();
        queryClient.invalidateQueries({ queryKey: ['products'] });
        queryClient.invalidateQueries({ queryKey: ['categories'] });
        queryClient.invalidateQueries({ queryKey: ['analytics'] });
        queryClient.invalidateQueries({ queryKey: ['orders'] });
    };

    if (!message) return null;

    return (
        <div
            role="alert"
            style={{
                position: 'sticky',
                top: 0,
                zIndex: 100,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '1rem',
                padding: '12px 20px',
                background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                color: '#fff',
                fontSize: '14px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            }}
        >
            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <AlertCircle size={20} />
                {message}
            </span>
            <button
                type="button"
                onClick={handleRetry}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '8px 16px',
                    background: 'rgba(255,255,255,0.2)',
                    border: '1px solid rgba(255,255,255,0.5)',
                    borderRadius: '8px',
                    color: '#fff',
                    cursor: 'pointer',
                    fontWeight: 600,
                }}
            >
                <RefreshCw size={16} />
                Tekrar dene
            </button>
        </div>
    );
};
